import script from "./ArrowList.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrowList.vue?vue&type=script&setup=true&lang=js"

import "./ArrowList.vue?vue&type=style&index=0&id=e410d206&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e410d206"]])

export default __exports__